import { render, staticRenderFns } from "./nav-footer.vue?vue&type=template&id=5037ea8c&scoped=true"
import script from "./nav-footer.vue?vue&type=script&lang=js"
export * from "./nav-footer.vue?vue&type=script&lang=js"
import style0 from "./nav-footer.vue?vue&type=style&index=0&id=5037ea8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5037ea8c",
  null
  
)

export default component.exports